import { ja } from "../../../../date-fns/locale/ja.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    ja
  }
};